import './sass/home.scss';
import { motion } from "framer-motion";
import { slideUp } from '../animations/sections';

function Home() {
  return (
    <section className="home">
      <div className="hs1 mt-5">
        <motion.h1 initial="hidden" animate="show" variants={slideUp({ delay: 0.50 })}>
          Hi, my name is
        </motion.h1>
      </div>
      <div className="hs2">
        <motion.h2 className="big-heading" initial="hidden" animate="show" variants={slideUp({ delay: 0.65 })}>
          Aryaman
        </motion.h2>
      </div>
      <div className="hs3">
        <motion.h3 initial="hidden" animate="show" variants={slideUp({ delay: 0.75 })}>
          <h3 className="big-heading">I'm a Full Stack Dev<br></br>& FOSS Contributor</h3>
        </motion.h3>
      </div>
      <div className="hs4">
        <motion.p initial="hidden" animate="show" variants={slideUp({ delay: 1 })}>
        <p>
          A tech enthusiast with a fervor for crafting solutions 
          that empower the opensource community 🧡 <br></br>
          I thrive on the challenge of turning innovative ideas into reality 🚀 <br></br>
        </p>
        </motion.p>
        <motion.p initial="hidden" animate="show" variants={slideUp({ delay: 1.25 })}>
          <a href="#about" className="more mt-5">More</a>
        </motion.p>
      </div>
    </section>
  );
}
export default Home;
